import API from "@/package/config/axios";
import { IAuthForm, IProfileResponse } from "@/types";
import { AxiosResponse } from "axios";

export const apiGetLogin = (user: IAuthForm) => {
  return API.post("auth/admin/login", user);
};

export const apiGetProfile = (): Promise<AxiosResponse<IProfileResponse>> => {
  return API.get("admin/user/profile");
};
